import React from "react";
import Banner from "../components/Banner";
import CollegeTour from "../components/CollegeTour";
import NewsEventsSection from "../components/NewsEventsSection";
import VisionAboutSection from "../components/VisionAboutSection";
import ChairmanMessageSection from "../components/ChairmanMessageSection";
import ContactSection from "../components/ContactSection";

const Home = () => {
  return (
    <>
      <Banner />
      <VisionAboutSection />
      <CollegeTour/>
      <NewsEventsSection />
      <ChairmanMessageSection/>
      <ContactSection/>
    </>
  );
};

export default Home;